(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
class AnnouncementBarCarousel extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.currentIndex = 0;
    this.timer = null;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.onCloseClick = this.onCloseClick.bind(this);
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.announcement-bar__item'));
    this.closeButton = this.querySelector('[data-announcement-close]');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.onCloseClick);
    }

    if (sessionStorage.getItem('bimo:announcement-dismissed') === 'true') {
      this.hidden = true;
      return;
    }

    const shouldAutorotate = this.dataset.autorotate === 'true' && this.items.length > 1;

    if (shouldAutorotate && !this.reducedMotion) {
      const interval = parseInt(this.dataset.interval, 10) || 5000;
      this.timer = window.setInterval(() => this.showNext(), interval);
    }
  }

  disconnectedCallback() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
    if (this.closeButton) {
      this.closeButton.removeEventListener('click', this.onCloseClick);
    }
  }

  showNext() {
    if (this.items.length < 2) return;

    const current = this.items[this.currentIndex];
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
    const next = this.items[this.currentIndex];

    current.hidden = true;
    current.setAttribute('aria-hidden', 'true');

    next.hidden = false;
    next.removeAttribute('aria-hidden');
    next.classList.add('is-entering');
    window.setTimeout(() => next.classList.remove('is-entering'), 500);
  }

  onCloseClick() {
    this.hidden = true;
    sessionStorage.setItem('bimo:announcement-dismissed', 'true');
  }
}

if (!customElements.get('announcement-bar-carousel')) {
  customElements.define('announcement-bar-carousel', AnnouncementBarCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"]) return;
  try {
    
class BeforeAfterSlider extends HTMLElement {
  constructor() {
    super();
    this.onInput = this.onInput.bind(this);
  }

  connectedCallback() {
    this.range = this.querySelector('[data-range]');
    this.beforeLayer = this.querySelector('[data-before-layer]');
    this.handle = this.querySelector('[data-handle]');

    if (!this.range) return;

    this.range.addEventListener('input', this.onInput);
    this.updatePosition(this.range.value);

    if (this.handle && 'IntersectionObserver' in window) {
      this.hintObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.handle.classList.add('is-hinting');
              this.hintObserver.disconnect();
            }
          });
        },
        { threshold: 0.6 }
      );
      this.hintObserver.observe(this);
    }
  }

  disconnectedCallback() {
    if (this.range) {
      this.range.removeEventListener('input', this.onInput);
    }
    if (this.hintObserver) {
      this.hintObserver.disconnect();
    }
  }

  onInput(event) {
    this.updatePosition(event.target.value);
  }

  updatePosition(value) {
    if (this.beforeLayer) {
      this.beforeLayer.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
    }
    if (this.handle) {
      this.handle.style.left = `${value}%`;
    }
  }
}

if (!customElements.get('before-after-slider')) {
  customElements.define('before-after-slider', BeforeAfterSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
class CartDrawerComponent extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onOpenEvent = this.onOpenEvent.bind(this);
    this.onCartUpdated = this.onCartUpdated.bind(this);
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;

    this.addEventListener('click', this.onClick);
    this.addEventListener('change', this.onChange);
    document.addEventListener('keydown', this.onKeydown);
    document.addEventListener('cart-drawer:open', this.onOpenEvent);
    document.addEventListener('cart:updated', this.onCartUpdated);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('change', this.onChange);
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('cart-drawer:open', this.onOpenEvent);
    document.removeEventListener('cart:updated', this.onCartUpdated);
  }

  onOpenEvent() {
    this.open();
  }

  onCartUpdated() {
    this.refresh().then(() => this.open());
  }

  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  onClick(event) {
    if (event.target.closest('[data-cart-overlay]') || event.target.closest('[data-cart-close]')) {
      this.close();
      return;
    }

    const qtyButton = event.target.closest('[data-quantity-increase], [data-quantity-decrease], [data-remove-item]');
    if (qtyButton) {
      this.handleQuantityButton(qtyButton);
    }
  }

  onChange(event) {
    const input = event.target.closest('[data-quantity-input]');
    if (!input) return;

    const line = input.dataset.line;
    const quantity = Math.max(0, parseInt(input.value, 10) || 0);
    this.updateLine(line, quantity);
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('is-open')) {
      this.close();
    }
  }

  handleQuantityButton(button) {
    const line = button.dataset.line;
    const input = this.querySelector(`[data-quantity-input][data-line="${line}"]`);
    let quantity = input ? parseInt(input.value, 10) || 0 : 0;

    if (button.hasAttribute('data-quantity-increase')) {
      quantity += 1;
    } else if (button.hasAttribute('data-quantity-decrease')) {
      quantity = Math.max(0, quantity - 1);
    } else if (button.hasAttribute('data-remove-item')) {
      quantity = 0;
      document.dispatchEvent(new CustomEvent('cart-save:trigger'));
    }

    this.updateLine(line, quantity);
  }

  updateLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: this.sectionId })
    })
      .then((response) => response.json())
      .then((data) => this.renderSection(data))
      .catch(() => {});
  }

  refresh() {
    return fetch(`${window.location.pathname}?sections=${this.sectionId}`)
      .then((response) => response.json())
      .then((data) => this.renderSection(data))
      .catch(() => {});
  }

  renderSection(data) {
    const html = (data.sections && data.sections[this.sectionId]) || data[this.sectionId];
    if (!html) return;

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newContent = parsed.querySelector('[data-cart-drawer-content]');
    const currentContent = this.querySelector('[data-cart-drawer-content]');

    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
    }

    this.syncHeaderCartCount();
  }

  syncHeaderCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const countEl = document.querySelector('[data-cart-count]');
        if (countEl) {
          countEl.textContent = cart.item_count;
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-save-offer"]) return;
  try {
    
class CartSaveOffer extends HTMLElement {
  constructor() {
    super();
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onCopyClick = this.onCopyClick.bind(this);
    this.onCartRemoveTrigger = this.onCartRemoveTrigger.bind(this);
    this.hasShown = false;
  }

  connectedCallback() {
    if (sessionStorage.getItem('bimo:cart-save-shown') === 'true') {
      return;
    }

    this.closeButtons = this.querySelectorAll('[data-save-close]');
    this.overlay = this.querySelector('[data-save-overlay]');
    this.copyButton = this.querySelector('[data-save-copy]');

    this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.close()));
    if (this.overlay) this.overlay.addEventListener('click', this.onOverlayClick);
    if (this.copyButton) this.copyButton.addEventListener('click', this.onCopyClick);
    document.addEventListener('keydown', this.onKeydown);

    const timeSeconds = parseInt(this.dataset.triggerTime, 10) || 0;
    if (timeSeconds > 0) {
      this.timeTimeout = window.setTimeout(() => this.open(), timeSeconds * 1000);
    }

    if (this.dataset.triggerExit === 'true') {
      this.exitEnableTimeout = window.setTimeout(() => {
        document.addEventListener('mouseleave', this.onMouseLeave);
      }, 8000);
    }

    if (this.dataset.triggerRemove === 'true') {
      document.addEventListener('cart-save:trigger', this.onCartRemoveTrigger);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('mouseleave', this.onMouseLeave);
    document.removeEventListener('keydown', this.onKeydown);
    document.removeEventListener('cart-save:trigger', this.onCartRemoveTrigger);
    if (this.timeTimeout) window.clearTimeout(this.timeTimeout);
    if (this.exitEnableTimeout) window.clearTimeout(this.exitEnableTimeout);
  }

  onMouseLeave(event) {
    if (event.clientY <= 0) {
      this.open();
    }
  }

  onCartRemoveTrigger() {
    this.open();
  }

  open() {
    if (this.hasShown) return;
    this.hasShown = true;
    sessionStorage.setItem('bimo:cart-save-shown', 'true');

    document.removeEventListener('mouseleave', this.onMouseLeave);
    document.removeEventListener('cart-save:trigger', this.onCartRemoveTrigger);
    if (this.timeTimeout) window.clearTimeout(this.timeTimeout);

    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
  }

  onOverlayClick() {
    this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('is-open')) {
      this.close();
    }
  }

  onCopyClick() {
    const code = this.copyButton.dataset.code;
    if (!code || !navigator.clipboard) return;

    navigator.clipboard.writeText(code).then(() => {
      const original = this.copyButton.textContent;
      this.copyButton.textContent = 'Copiado ✓';
      window.setTimeout(() => {
        this.copyButton.textContent = original;
      }, 2000);
    }).catch(() => {});
  }
}

if (!customElements.get('cart-save-offer')) {
  customElements.define('cart-save-offer', CartSaveOffer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["complete-routine"]) return;
  try {
    
class RoutineQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.onAddClick = this.onAddClick.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('[data-quick-add]');
    this.variantId = this.button ? this.button.dataset.variantId : null;
    this.defaultLabel = this.button ? this.button.textContent : '';

    if (this.button) {
      this.button.addEventListener('click', this.onAddClick);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.onAddClick);
    }
  }

  onAddClick() {
    if (!this.variantId || this.button.disabled) return;

    this.button.disabled = true;
    this.button.textContent = 'Agregando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this.variantId, quantity: 1 })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || 'No se pudo agregar');
        }
        this.button.textContent = 'Agregado ✓';
        this.updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        window.setTimeout(() => {
          this.button.textContent = this.defaultLabel;
          this.button.disabled = false;
        }, 2000);
      })
      .catch(() => {
        this.button.textContent = 'Reintentar';
        this.button.disabled = false;
      });
  }

  updateCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const countEl = document.querySelector('[data-cart-count]');
        if (countEl) {
          countEl.textContent = cart.item_count;
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('routine-quick-add')) {
  customElements.define('routine-quick-add', RoutineQuickAdd);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delivery-estimate"]) return;
  try {
    
class DeliveryEstimateCalculator extends HTMLElement {
  connectedCallback() {
    const shipDelay = parseInt(this.dataset.shipDelay, 10) || 1;
    const deliveryMin = parseInt(this.dataset.deliveryMin, 10) || 3;
    const deliveryMax = parseInt(this.dataset.deliveryMax, 10) || 5;

    const purchaseDate = new Date();
    const shipDate = this.addCalendarDays(purchaseDate, shipDelay);
    const deliveryMinDate = this.addBusinessDays(shipDate, deliveryMin);
    const deliveryMaxDate = this.addBusinessDays(shipDate, deliveryMax);

    this.setText('[data-date-purchase]', this.formatDate(purchaseDate));
    this.setText('[data-date-ship]', this.formatDate(shipDate));
    this.setText('[data-date-delivery]', this.formatRange(deliveryMinDate, deliveryMaxDate));
  }

  setText(selector, text) {
    const el = this.querySelector(selector);
    if (el) el.textContent = text;
  }

  addCalendarDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  getMonths() {
    return ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  }

  formatDate(date) {
    return `${date.getDate()} de ${this.getMonths()[date.getMonth()]}`;
  }

  formatRange(minDate, maxDate) {
    const months = this.getMonths();
    if (minDate.getMonth() === maxDate.getMonth()) {
      return `${minDate.getDate()} - ${maxDate.getDate()} de ${months[minDate.getMonth()]}`;
    }
    return `${minDate.getDate()} de ${months[minDate.getMonth()]} - ${maxDate.getDate()} de ${months[maxDate.getMonth()]}`;
  }
}

if (!customElements.get('delivery-estimate-calculator')) {
  customElements.define('delivery-estimate-calculator', DeliveryEstimateCalculator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exit-intent-offer"]) return;
  try {
    
class ExitIntentOffer extends HTMLElement {
  constructor() {
    super();
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onCopyClick = this.onCopyClick.bind(this);
    this.hasShown = false;
  }

  connectedCallback() {
    if (sessionStorage.getItem('bimo:exit-offer-shown') === 'true') {
      return;
    }

    this.closeButtons = this.querySelectorAll('[data-exit-close]');
    this.overlay = this.querySelector('[data-exit-overlay]');
    this.copyButton = this.querySelector('[data-exit-copy]');

    this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.close()));
    if (this.overlay) this.overlay.addEventListener('click', this.onOverlayClick);
    if (this.copyButton) this.copyButton.addEventListener('click', this.onCopyClick);
    document.addEventListener('keydown', this.onKeydown);

    this.enableTimeout = window.setTimeout(() => {
      document.addEventListener('mouseleave', this.onMouseLeave);
      this.idleTimeout = window.setTimeout(() => this.open(), 30000);
    }, 15000);
  }

  disconnectedCallback() {
    document.removeEventListener('mouseleave', this.onMouseLeave);
    document.removeEventListener('keydown', this.onKeydown);
    if (this.enableTimeout) window.clearTimeout(this.enableTimeout);
    if (this.idleTimeout) window.clearTimeout(this.idleTimeout);
  }

  onMouseLeave(event) {
    if (event.clientY <= 0) {
      this.open();
    }
  }

  open() {
    if (this.hasShown) return;
    this.hasShown = true;
    sessionStorage.setItem('bimo:exit-offer-shown', 'true');
    document.removeEventListener('mouseleave', this.onMouseLeave);
    if (this.idleTimeout) window.clearTimeout(this.idleTimeout);

    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
  }

  onOverlayClick() {
    this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.classList.contains('is-open')) {
      this.close();
    }
  }

  onCopyClick() {
    const code = this.copyButton.dataset.code;
    if (!code || !navigator.clipboard) return;

    navigator.clipboard.writeText(code).then(() => {
      const original = this.copyButton.textContent;
      this.copyButton.textContent = 'Copiado ✓';
      window.setTimeout(() => {
        this.copyButton.textContent = original;
      }, 2000);
    }).catch(() => {});
  }
}

if (!customElements.get('exit-intent-offer')) {
  customElements.define('exit-intent-offer', ExitIntentOffer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"]) return;
  try {
    
class FeaturedQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.onAddClick = this.onAddClick.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('[data-quick-add]');
    this.variantId = this.button ? this.button.dataset.variantId : null;
    this.defaultLabel = this.button ? this.button.textContent : '';

    if (this.button) {
      this.button.addEventListener('click', this.onAddClick);
    }
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener('click', this.onAddClick);
    }
  }

  onAddClick() {
    if (!this.variantId || this.button.disabled) return;

    this.button.disabled = true;
    this.button.textContent = 'Agregando...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this.variantId, quantity: 1 })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || 'No se pudo agregar');
        }
        this.button.textContent = 'Agregado ✓';
        this.updateCartCount();
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        window.setTimeout(() => {
          this.button.textContent = this.defaultLabel;
          this.button.disabled = false;
        }, 2000);
      })
      .catch(() => {
        this.button.textContent = 'Reintentar';
        this.button.disabled = false;
      });
  }

  updateCartCount() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const countEl = document.querySelector('[data-cart-count]');
        if (countEl) {
          countEl.textContent = cart.item_count;
        }
      })
      .catch(() => {});
  }
}

if (!customElements.get('featured-quick-add')) {
  customElements.define('featured-quick-add', FeaturedQuickAdd);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-whatsapp"]) return;
  try {
    
class WhatsappFloat extends HTMLElement {
  constructor() {
    super();
    this.onStickyBarToggle = this.onStickyBarToggle.bind(this);
  }

  connectedCallback() {
    document.addEventListener('sticky-bar:toggle', this.onStickyBarToggle);
  }

  disconnectedCallback() {
    document.removeEventListener('sticky-bar:toggle', this.onStickyBarToggle);
  }

  onStickyBarToggle(event) {
    this.classList.toggle('is-raised', !!(event.detail && event.detail.visible));
  }
}

if (!customElements.get('whatsapp-float')) {
  customElements.define('whatsapp-float', WhatsappFloat);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class HeaderComponent extends HTMLElement {
  constructor() {
    super();
    this.onMenuToggleClick = this.onMenuToggleClick.bind(this);
    this.onMobileCloseClick = this.onMobileCloseClick.bind(this);
    this.onCartToggleClick = this.onCartToggleClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onTransparentScroll = this.onTransparentScroll.bind(this);
    this.updateTransparentOffset = this.updateTransparentOffset.bind(this);
    this.lastScrollY = window.scrollY;
    this.ticking = false;
  }

  connectedCallback() {
    this.header = this.querySelector('.site-header');
    this.sentinel = this.querySelector('.site-header__sentinel');
    this.placeholder = this.querySelector('[data-header-placeholder]');
    this.menuToggle = this.querySelector('[data-menu-toggle]');
    this.mobileNav = this.querySelector('[data-mobile-nav]');
    this.mobileClose = this.querySelector('[data-mobile-close]');
    this.isSticky = this.dataset.sticky === 'true';
    this.hideOnScroll = this.dataset.hideOnScroll === 'true';
    this.isTransparentMode = this.dataset.transparent === 'true';

    if (this.isTransparentMode) {
      this.header.classList.add('is-transparent-mode');
      this.updateTransparentOffset();
      this.onTransparentScroll();
      window.addEventListener('scroll', this.onTransparentScroll, { passive: true });
      window.addEventListener('resize', this.updateTransparentOffset, { passive: true });
    } else if (this.isSticky && this.sentinel && 'IntersectionObserver' in window) {
      this.stickyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const shouldStick = !entry.isIntersecting;
            const headerHeight = this.header.offsetHeight;

            this.header.classList.toggle('is-stuck', shouldStick);

            if (this.placeholder) {
              this.placeholder.style.height = shouldStick ? `${headerHeight}px` : '0px';
            }
          });
        },
        { threshold: 0 }
      );
      this.stickyObserver.observe(this.sentinel);

      if (this.hideOnScroll) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    if (this.menuToggle) {
      this.menuToggle.addEventListener('click', this.onMenuToggleClick);
    }

    if (this.mobileClose) {
      this.mobileClose.addEventListener('click', this.onMobileCloseClick);
    }

    this.cartToggle = this.querySelector('[data-cart-toggle]');
    if (this.cartToggle) {
      this.cartToggle.addEventListener('click', this.onCartToggleClick);
    }

    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
    }
    if (this.menuToggle) {
      this.menuToggle.removeEventListener('click', this.onMenuToggleClick);
    }
    if (this.mobileClose) {
      this.mobileClose.removeEventListener('click', this.onMobileCloseClick);
    }
    if (this.cartToggle) {
      this.cartToggle.removeEventListener('click', this.onCartToggleClick);
    }
    document.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('scroll', this.onTransparentScroll);
    window.removeEventListener('resize', this.updateTransparentOffset);
  }

  updateTransparentOffset() {
    const announcementBar = document.querySelector('.announcement-bar');
    this.announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
    this.applyTransparentTop();
  }

  applyTransparentTop() {
    const offset = Math.max(0, this.announcementBarHeight - window.scrollY);
    this.header.style.top = `${offset}px`;
  }

  onTransparentScroll() {
    const scrolled = window.scrollY > 60;
    this.header.classList.toggle('is-scrolled', scrolled);
    this.applyTransparentTop();
  }

  onCartToggleClick() {
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;

    window.requestAnimationFrame(() => {
      const currentY = window.scrollY;
      const scrollingDown = currentY > this.lastScrollY;
      const pastThreshold = currentY > 160;

      this.header.classList.toggle('is-hidden', scrollingDown && pastThreshold);

      this.lastScrollY = currentY;
      this.ticking = false;
    });
  }

  onMenuToggleClick() {
    const isOpen = this.mobileNav.classList.toggle('is-open');
    this.menuToggle.setAttribute('aria-expanded', String(isOpen));

    if (isOpen) {
      this.mobileNav.removeAttribute('aria-hidden');
      this.mobileNav.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      const firstLink = this.mobileNav.querySelector('a');
      if (firstLink) firstLink.focus();
    } else {
      this.closeMobileNav();
    }
  }

  onMobileCloseClick() {
    this.closeMobileNav();
  }

  closeMobileNav() {
    this.mobileNav.classList.remove('is-open');
    this.mobileNav.setAttribute('aria-hidden', 'true');
    this.mobileNav.setAttribute('inert', '');
    this.menuToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  onKeydown(event) {
    if (event.key === 'Escape' && this.mobileNav.classList.contains('is-open')) {
      this.closeMobileNav();
      this.menuToggle.focus();
    }
  }
}

if (!customElements.get('header-component')) {
  customElements.define('header-component', HeaderComponent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
class CartPageComponent extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.addEventListener('click', this.onClick);
    this.addEventListener('change', this.onChange);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('change', this.onChange);
  }

  onClick(event) {
    const button = event.target.closest('[data-quantity-increase], [data-quantity-decrease], [data-remove-item]');
    if (!button) return;

    const line = button.dataset.line;
    const input = this.querySelector(`[data-quantity-input][data-line="${line}"]`);
    let quantity = input ? parseInt(input.value, 10) || 0 : 0;

    if (button.hasAttribute('data-quantity-increase')) {
      quantity += 1;
    } else if (button.hasAttribute('data-quantity-decrease')) {
      quantity = Math.max(0, quantity - 1);
    } else if (button.hasAttribute('data-remove-item')) {
      quantity = 0;
      document.dispatchEvent(new CustomEvent('cart-save:trigger'));
    }

    this.updateLine(line, quantity);
  }

  onChange(event) {
    const input = event.target.closest('[data-quantity-input]');
    if (!input) return;

    const line = input.dataset.line;
    const quantity = Math.max(0, parseInt(input.value, 10) || 0);
    this.updateLine(line, quantity);
  }

  updateLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: this.sectionId })
    })
      .then((response) => response.json())
      .then((data) => this.renderSection(data))
      .catch(() => {
        window.location.reload();
      });
  }

  renderSection(data) {
    const html = data.sections && data.sections[this.sectionId];
    if (!html) {
      window.location.reload();
      return;
    }

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newContent = parsed.querySelector('[data-cart-page-content]');
    const currentContent = this.querySelector('[data-cart-page-content]');
    const newTitle = parsed.querySelector('[data-cart-page-title]');
    const currentTitle = this.querySelector('[data-cart-page-title]');

    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
    }
    if (newTitle && currentTitle) {
      currentTitle.innerHTML = newTitle.innerHTML;
    }

    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const countEl = document.querySelector('[data-cart-count]');
        if (countEl) countEl.textContent = cart.item_count;
      })
      .catch(() => {});
  }
}

if (!customElements.get('cart-page-component')) {
  customElements.define('cart-page-component', CartPageComponent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.onFilterToggleClick = this.onFilterToggleClick.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.form = this.querySelector('[data-facet-form]');
    this.sortSelect = this.querySelector('[data-sort-select]');
    this.filterToggle = this.querySelector('[data-filter-toggle]');
    this.filtersPanel = this.querySelector('[data-filters-panel]');

    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit);
      this.form.addEventListener('change', this.onCheckboxChange);
    }
    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', this.onSortChange);
    }
    if (this.filterToggle) {
      this.filterToggle.addEventListener('click', this.onFilterToggleClick);
    }
  }

  disconnectedCallback() {
    if (this.form) {
      this.form.removeEventListener('submit', this.onFormSubmit);
      this.form.removeEventListener('change', this.onCheckboxChange);
    }
    if (this.sortSelect) {
      this.sortSelect.removeEventListener('change', this.onSortChange);
    }
    if (this.filterToggle) {
      this.filterToggle.removeEventListener('click', this.onFilterToggleClick);
    }
  }

  onFilterToggleClick() {
    const isOpen = !this.filtersPanel.hasAttribute('hidden');
    if (isOpen) {
      this.filtersPanel.setAttribute('hidden', '');
      this.filterToggle.setAttribute('aria-expanded', 'false');
    } else {
      this.filtersPanel.removeAttribute('hidden');
      this.filterToggle.setAttribute('aria-expanded', 'true');
    }
  }

  onSortChange() {
    this.submitForm();
  }

  onCheckboxChange(event) {
    if (event.target.matches('input[type="checkbox"]')) {
      this.submitForm();
    }
  }

  onFormSubmit(event) {
    event.preventDefault();
    this.submitForm();
  }

  submitForm() {
    const formData = new FormData(this.form);
    const params = new URLSearchParams();

    for (const [key, value] of formData.entries()) {
      if (value) params.append(key, value);
    }

    const baseUrl = this.form.getAttribute('action') || window.location.pathname;
    const queryString = params.toString();
    const newUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl;
    const fetchUrl = `${newUrl}${queryString ? '&' : '?'}section_id=${this.sectionId}`;

    this.setLoading(true);

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        this.swapContent(parsed, '[data-product-grid]');
        this.swapContent(parsed, '[data-filters-panel]');
        this.swapContent(parsed, '[data-product-count]');
        window.history.pushState({}, '', newUrl);
        this.setLoading(false);
      })
      .catch(() => {
        window.location.href = newUrl;
      });
  }

  swapContent(parsedDoc, selector) {
    const newEl = parsedDoc.querySelector(selector);
    const currentEl = document.querySelector(selector);
    if (newEl && currentEl) {
      currentEl.innerHTML = newEl.innerHTML;
    }
  }

  setLoading(isLoading) {
    const grid = document.querySelector('[data-product-grid]');
    if (grid) {
      grid.classList.toggle('is-loading', isLoading);
    }
  }
}

if (!customElements.get('collection-filters')) {
  customElements.define('collection-filters', CollectionFilters);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
class ProductHeroGalleryAndForm extends HTMLElement {
  constructor() {
    super();
    this.onThumbClick = this.onThumbClick.bind(this);
    this.onOptionChange = this.onOptionChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  connectedCallback() {
    this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
    this.mainImages = Array.from(this.querySelectorAll('[data-main-image]'));
    this.optionGroups = Array.from(this.querySelectorAll('[data-option-group]'));
    this.variantInput = this.querySelector('[data-variant-id]');
    this.priceEl = this.querySelector('.product-hero__price-now');
    this.stickyPriceEl = this.querySelector('[data-sticky-price]');
    this.stockEl = this.querySelector('[data-stock-indicator]');
    this.addToCartBtn = this.querySelector('[data-add-to-cart]');
    this.stickyCartBtn = this.querySelector('.product-hero__sticky-cta');
    this.ctaSentinel = this.querySelector('[data-cta-sentinel]');
    this.stickyBar = this.querySelector('[data-sticky-bar]');

    const variantsData = this.querySelector('[data-product-variants]');
    this.variants = variantsData ? JSON.parse(variantsData.textContent) : [];

    this.form = this.querySelector('[data-product-form]');
    if (this.form) {
      this.form.addEventListener('submit', this.onFormSubmit);
    }

    this.thumbs.forEach((thumb) => thumb.addEventListener('click', this.onThumbClick));
    this.addEventListener('change', this.onOptionChange);

    if (this.ctaSentinel && this.stickyBar && 'IntersectionObserver' in window) {
      this.stickyObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
            document.dispatchEvent(new CustomEvent('sticky-bar:toggle', { detail: { visible: !entry.isIntersecting } }));
          });
        },
        { rootMargin: '0px 0px -15% 0px' }
      );
      this.stickyObserver.observe(this.ctaSentinel);
    }
  }

  disconnectedCallback() {
    this.thumbs.forEach((thumb) => thumb.removeEventListener('click', this.onThumbClick));
    this.removeEventListener('change', this.onOptionChange);
    if (this.form) {
      this.form.removeEventListener('submit', this.onFormSubmit);
    }
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
    }
  }

  onFormSubmit(event) {
    if (!this.variantInput || !this.variantInput.value) return;
    if (this.addToCartBtn && this.addToCartBtn.disabled) return;

    event.preventDefault();

    const originalLabel = this.addToCartBtn ? this.addToCartBtn.textContent : '';
    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.textContent = 'Agregando...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this.variantInput.value, quantity: 1 })
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || 'No se pudo agregar');
        }

        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));

        const hasDrawer = document.querySelector('cart-drawer-component');
        if (!hasDrawer) {
          window.location.href = this.dataset.cartUrl || '/cart';
          return;
        }

        if (this.addToCartBtn) {
          this.addToCartBtn.textContent = 'Agregado ✓';
          window.setTimeout(() => {
            this.addToCartBtn.textContent = originalLabel;
            this.addToCartBtn.disabled = false;
          }, 2000);
        }
      })
      .catch(() => {
        // Si el AJAX falla por cualquier motivo, se envía el formulario de verdad como respaldo
        this.form.submit();
      });
  }

  onThumbClick(event) {
    const mediaId = event.currentTarget.dataset.mediaId;

    this.thumbs.forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
    });

    this.mainImages.forEach((image) => {
      const isMatch = image.dataset.mediaId === mediaId;
      image.hidden = !isMatch;
      image.classList.toggle('is-active', isMatch);
    });
  }

  onOptionChange(event) {
    if (event && event.target && !event.target.matches('[data-option-control]')) return;
    if (this.optionGroups.length === 0 || this.variants.length === 0) return;

    const selectedValues = this.optionGroups.map((group) => {
      const checkedRadio = group.querySelector('input[data-option-control]:checked');
      if (checkedRadio) return checkedRadio.value;
      const select = group.querySelector('select[data-option-control]');
      return select ? select.value : '';
    });

    const matchedVariant = this.variants.find((variant) =>
      variant.options.every((value, index) => value === selectedValues[index])
    );

    this.optionGroups.forEach((group) => {
      group.querySelectorAll('[data-tier]').forEach((tier) => {
        const radio = tier.querySelector('input[data-option-control]');
        tier.classList.toggle('is-selected', !!(radio && radio.checked));
      });
    });

    if (!matchedVariant) return;

    this.variantInput.value = matchedVariant.id;
    this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));

    if (this.priceEl) this.priceEl.textContent = matchedVariant.price;
    if (this.stickyPriceEl) this.stickyPriceEl.textContent = matchedVariant.price;

    [this.addToCartBtn, this.stickyCartBtn].forEach((btn) => {
      if (!btn) return;
      btn.disabled = !matchedVariant.available;
    });

    if (this.addToCartBtn) {
      this.addToCartBtn.textContent = matchedVariant.available ? 'Agregar al carrito' : 'Agotado';
    }

    if (this.stockEl) {
      this.updateStockIndicator(matchedVariant);
    }
  }

  updateStockIndicator(variant) {
    if (!variant.available) {
      this.stockEl.innerHTML = '<span class="product-hero__stock-dot product-hero__stock-dot--out"></span> Agotado temporalmente';
      return;
    }

    if (variant.inventory_management === 'shopify' && variant.inventory_quantity <= 10 && variant.inventory_quantity > 0) {
      this.stockEl.innerHTML = `<span class="product-hero__stock-dot product-hero__stock-dot--low"></span> Quedan ${variant.inventory_quantity} unidades`;
    } else {
      this.stockEl.innerHTML = '<span class="product-hero__stock-dot"></span> Disponible para envío inmediato';
    }
  }
}

if (!customElements.get('product-hero-gallery-and-form')) {
  customElements.define('product-hero-gallery-and-form', ProductHeroGalleryAndForm);
}

class DeliveryEstimateCalculator extends HTMLElement {
  connectedCallback() {
    const shipDelay = parseInt(this.dataset.shipDelay, 10) || 1;
    const deliveryMin = parseInt(this.dataset.deliveryMin, 10) || 3;
    const deliveryMax = parseInt(this.dataset.deliveryMax, 10) || 5;

    const purchaseDate = new Date();
    const shipDate = this.addCalendarDays(purchaseDate, shipDelay);
    const deliveryMinDate = this.addBusinessDays(shipDate, deliveryMin);
    const deliveryMaxDate = this.addBusinessDays(shipDate, deliveryMax);

    this.setText('[data-date-purchase]', this.formatDate(purchaseDate));
    this.setText('[data-date-ship]', this.formatDate(shipDate));
    this.setText('[data-date-delivery]', this.formatRange(deliveryMinDate, deliveryMaxDate));
  }

  setText(selector, text) {
    const el = this.querySelector(selector);
    if (el) el.textContent = text;
  }

  addCalendarDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) {
        added++;
      }
    }
    return result;
  }

  getMonths() {
    return ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  }

  formatDate(date) {
    return `${date.getDate()} de ${this.getMonths()[date.getMonth()]}`;
  }

  formatRange(minDate, maxDate) {
    const months = this.getMonths();
    if (minDate.getMonth() === maxDate.getMonth()) {
      return `${minDate.getDate()} - ${maxDate.getDate()} de ${months[minDate.getMonth()]}`;
    }
    return `${minDate.getDate()} de ${months[minDate.getMonth()]} - ${maxDate.getDate()} de ${months[maxDate.getMonth()]}`;
  }
}

if (!customElements.get('delivery-estimate-calculator')) {
  customElements.define('delivery-estimate-calculator', DeliveryEstimateCalculator);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
class RelatedProductsComponent extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const sourceContent = parsed.querySelector('[data-content]');
        const targetContent = this.querySelector('[data-content]');

        if (sourceContent && targetContent && sourceContent.innerHTML.trim().length > 0) {
          targetContent.innerHTML = sourceContent.innerHTML;
        } else {
          this.remove();
        }
      })
      .catch(() => {
        this.remove();
      });
  }
}

if (!customElements.get('related-products-component')) {
  customElements.define('related-products-component', RelatedProductsComponent);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["results"]) return;
  try {
    
class ResultCounter extends HTMLElement {
  connectedCallback() {
    this.target = parseFloat(this.dataset.target) || 0;
    this.suffix = this.dataset.suffix || '';
    this.hasAnimated = false;
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.prefersReducedMotion || !('IntersectionObserver' in window)) {
      this.textContent = this.formatValue(this.target);
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.hasAnimated = true;
            this.animateCount();
            this.observer.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  animateCount() {
    const duration = 1200;
    const start = performance.now();
    const isInteger = Number.isInteger(this.target);

    const step = (now) => {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = this.target * eased;

      this.textContent = this.formatValue(current, isInteger);

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        this.textContent = this.formatValue(this.target, isInteger);
      }
    };

    requestAnimationFrame(step);
  }

  formatValue(value, isInteger) {
    const rounded = isInteger ? Math.round(value) : Math.round(value * 10) / 10;
    return `${rounded}${this.suffix}`;
  }
}

if (!customElements.get('result-counter')) {
  customElements.define('result-counter', ResultCounter);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof-video"]) return;
  try {
    
class UgcVideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.onMuteToggle = this.onMuteToggle.bind(this);
  }

  connectedCallback() {
    this.video = this.querySelector('[data-video]');
    this.muteButton = this.querySelector('[data-mute-toggle]');
    this.mutedIcon = this.querySelector('[data-icon-muted]');
    this.unmutedIcon = this.querySelector('[data-icon-unmuted]');

    if (this.muteButton) {
      this.muteButton.addEventListener('click', this.onMuteToggle);
    }

    if (this.video && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.video.play().catch(function () {});
            } else {
              this.video.pause();
            }
          });
        },
        { threshold: 0.6 }
      );
      this.observer.observe(this.video);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.muteButton) {
      this.muteButton.removeEventListener('click', this.onMuteToggle);
    }
  }

  onMuteToggle() {
    if (!this.video) return;

    this.video.muted = !this.video.muted;
    const isMuted = this.video.muted;

    this.muteButton.setAttribute('aria-pressed', String(!isMuted));
    this.muteButton.setAttribute('aria-label', isMuted ? 'Activar sonido' : 'Silenciar');

    if (this.mutedIcon) this.mutedIcon.hidden = !isMuted;
    if (this.unmutedIcon) this.unmutedIcon.hidden = isMuted;
  }
}

if (!customElements.get('ugc-video-player')) {
  customElements.define('ugc-video-player', UgcVideoPlayer);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urgency-bar"]) return;
  try {
    
class UrgencyCountdown extends HTMLElement {
  connectedCallback() {
    this.endEpoch = parseInt(this.dataset.end, 10);
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    if (!this.endEpoch) return;

    this.tick();
    this.interval = window.setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) {
      window.clearInterval(this.interval);
    }
  }

  tick() {
    const nowEpoch = Math.floor(Date.now() / 1000);
    const remaining = this.endEpoch - nowEpoch;

    if (remaining <= 0) {
      if (this.interval) window.clearInterval(this.interval);
      this.remove();
      return;
    }

    const days = Math.floor(remaining / 86400);
    const hours = Math.floor((remaining % 86400) / 3600);
    const minutes = Math.floor((remaining % 3600) / 60);
    const seconds = remaining % 60;

    if (this.daysEl) this.daysEl.textContent = days;
    if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
    if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
    if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
  }

  pad(value) {
    return value < 10 ? `0${value}` : `${value}`;
  }
}

if (!customElements.get('urgency-countdown')) {
  customElements.define('urgency-countdown', UrgencyCountdown);
}

  } catch(e) { console.error(e); }
})();
})();
